import { TooltipButton } from '@/components/ui/TooltipButton'
import { TreeAction, TreeNode } from '../types'
import { DataTableV2SubmissionAction } from '../../DataTableV2/types'
import { Button } from '@/components/shadcn/button'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import clsx from 'clsx'
import { useSubmitForm } from '../../FormComponent/useSubmitForm'
import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'

export function TreeNavigatorActions({
  actions,
  selectedPathNodes,
}: {
  actions: TreeAction[]
  selectedPathNodes: TreeNode[]
}) {
  if (!actions || actions.length === 0) return null

  return actions.map((action) => {
    if (!action.isVisible) return null
    switch (action.type) {
      case 'submit': {
        const submitAction = action as DataTableV2SubmissionAction
        return (
          <SubmitActionNoConfirmation
            key={action.id}
            action={submitAction}
            selectedPathNodes={selectedPathNodes}
          />
        )
      }
      // case 'sheet-content': {
      //   const sheetContentAction = action as DataTableV2SheetContentAction
      //   const trigger = (
      //     <TooltipButton tooltip={action.label}>
      //       <SheetTrigger asChild>
      //         <Button
      //           disabled={action.isDisabled}
      //           className={clsx('h-8', { 'w-8 rounded-full': action.icon })}
      //           variant="ghost"
      //           size={action.icon ? 'icon' : 'sm'}
      //         >
      //           {action.icon && <DynamicIcon iconName={action.icon} />}
      //           {action.label && <span className={action.icon ? 'sr-only' : ''}>{action.label}</span>}
      //         </Button>
      //       </SheetTrigger>
      //     </TooltipButton>
      //   )
      //   return <SheetContentAction key={action.id} action={sheetContentAction} trigger={trigger} />
      // }
      default:
        return null
    }
  })
}

function SubmitActionNoConfirmation({
  action,
  selectedPathNodes,
}: {
  action: DataTableV2SubmissionAction
  selectedPathNodes: TreeNode[]
}) {
  const { handlerId, id: actionId, label, icon, isDisabled } = action
  const { tileFilterSelections } = useTileFilters()
  const { mutate: submitForm } = useSubmitForm(handlerId, [...tileFilterSelections, { actionId }], actionId)
  return (
    <TooltipButton tooltip={label}>
      <Button
        variant="ghost"
        className={clsx('h-8', { 'w-8 rounded-full': icon })}
        size={icon ? 'icon' : 'sm'}
        disabled={isDisabled}
        onClick={() => submitForm({ selectedPathNodes })}
      >
        {icon && <DynamicIcon iconName={icon} />}
        {label && <span className={icon ? 'sr-only' : ''}>{label}</span>}
      </Button>
    </TooltipButton>
  )
}
